/**
 * Reads a picked file as UTF-8 text. `FileReader`, not `Blob.text()`: the jsdom
 * jest runs on (16.x) does not implement `Blob.text`, so every test touching it
 * would fail for no reason.
 */
export function readFileAsText(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read the file'));
    reader.readAsText(file);
  });
}
